import dayjs from 'dayjs'
import 'dayjs/locale/uk'

/**
 * Українська локаль dayjs для всього застосунку (D-16).
 *
 * `antd/locale/uk_UA` у `ConfigProvider` перекладає лише підписи antd
 * («Сьогодні», «Оберіть дату»), а назви місяців і днів тижня в `DatePicker`,
 * календарі й `dayjs().format('MMMM')` бере глобальна локаль dayjs — без неї
 * вони англійською. Імпортується з `main.tsx` до першого рендеру.
 *
 * ⚠️ `dayjs` у `package.json` не оголошений: це залежність antd, якою проєкт
 * уже користується напряму (той самий примірник, що й в antd). Оголосити його
 * явно — окреме рішення про залежність.
 */
export const APP_DAYJS_LOCALE = 'uk'

dayjs.locale(APP_DAYJS_LOCALE)
